import { EnvironmentProviders, Provider, importProvidersFrom } from '@angular/core';

import { mediaFeatureKey } from '@frontend/sports/grid/media/feature/state';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { StateStorageModule } from '../store-persist/state-storage.module';
import { MediaStateSaver } from './media-state-storage';
import { MediaEffects } from './media.epic';
import { mediaReducer } from './media.reducer';

export function provideMedia(): (Provider | EnvironmentProviders)[] {
    return [
        provideState(mediaFeatureKey, mediaReducer),
        provideEffects([MediaEffects]),
        importProvidersFrom(StateStorageModule.forFeature(mediaFeatureKey, MediaStateSaver)),
    ];
}
